import { useTranslation } from "react-i18next";

import { Tag } from "@aviary";
import { useCatalogSearch, useIngredientRemove } from "@shared/hooks";
import { l } from "@shared/locales/i18n";

import * as styles from "./IngredientFilterTagsWithExclusions.styles";

const IngredientFilterTagsWithExclusions = () => {
  const { t } = useTranslation();
  const { activeIngredients, excludedIngredients } = useCatalogSearch();
  const { removeIngredient } = useIngredientRemove();

  const renderActiveIngredientTags = () =>
    activeIngredients.map(ingredientFilter => (
      <Tag
        css={styles.tag}
        key={ingredientFilter?.name}
        text={ingredientFilter?.name}
        handleClick={() => {
          removeIngredient(ingredientFilter, false);
        }}
      />
    ));

  const renderExcludedIngredientTags = () =>
    excludedIngredients.map(ingredientFilter => (
      <Tag
        css={[styles.tag, styles.excludedStyles]}
        key={ingredientFilter?.name}
        text={t(l.sharedCatalog.excludeSearch.Exclude) + ": " + ingredientFilter.name}
        handleClick={() => {
          removeIngredient(ingredientFilter, true);
        }}
      />
    ));

  return (
    <>
      {renderActiveIngredientTags()}
      {renderExcludedIngredientTags()}
    </>
  );
};

export { IngredientFilterTagsWithExclusions };
